import * as ng from 'angular';
import { ComponentRegistration } from '../core';
let template = require('./email.html');

class EmailComponent extends ComponentRegistration {

    constructor() {
        super('email', {
            controller: EmailController,
            templateUrl: template,
            controllerAs: 'email',
            bindings: {
                name: "@?",
                label: '@?',
                required: '=?',
                value: '=?',
                ngDisabled: "=?",
                form: "&?",
                change: "&?",
                blur: "&?"
            }
        });
    }
}

interface IEmailController {
    validate(): void;
    assureInitValidation(): void;
    getRegExp(): RegExp;
    onChange(): void;
    onBlur(): void;
}

class EmailController implements IEmailController {
    private static $inject: Array<string> = ['$scope', '$timeout'];

    //private fields
    private fieldName: string;
    private displayLabel: string;
    private isRequired: Boolean;
    private hostForm: ng.IFormController;
    private field: any;
    public validationPattern = this.getRegExp();

    //bindings
    private name: string;
    private label: string;
    private required: Boolean;
    private value: string;
    private ngDisabled: Boolean;
    private form: Function;
    private change: Function;
    private blur: Function;

    constructor(private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService) {

        console.log("email controller loaded.");

    }

    public $onInit(): void {
        this.value = this.value || '';
        this.fieldName = this.name || 'email';
        this.displayLabel = this.label || 'Email';
        this.isRequired = this.required || false;
        this.ngDisabled = this.ngDisabled || false;

        this.hostForm = this.form();

        if (!this.hostForm)
            throw "Form reference was not resolved by the execution of the expression.";

        let self = this;
        var handleRevoker = this.$scope.$watch("email.value", (oldVal, newVal) => {
            if (oldVal != newVal) {
                self.validate();
                handleRevoker();
            }
        });

        this.assureInitValidation();

        console.log("Phone controller activated.");
    }

    public validate(): void {
        //use the ng-message name as the key for the set validity function
        //boolean expression that describes valid.
        let field = this.field = this.hostForm[this.fieldName] as any;

        //email conditionally required
        if (field) {
            // field.$setValidity('required', !email.isRequired || email.isRequired && email.value !== "");
            //field.$setValidity('invalid', validateEmail(email.value));
        }
    }

    public assureInitValidation(): void {
        if (this.hostForm[this.fieldName]) {
            this.validate();
        } else {
            setTimeout(() => {
                this.assureInitValidation();
            }, 500)
        }
    }

    public getRegExp(): RegExp {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    }

    public onChange(): void {
        this.validate();
        if (this.change) {
            this.$timeout(() => {
                this.change();
            });
        }
    }

    public onBlur(): void {
        this.validate();
        if (this.blur) {
            this.blur();
        }
    }

}

let emComponent = new EmailComponent();
export default emComponent;
export { emComponent as EmailComponent, IEmailController, EmailController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/user-controls/email.ts